import {getUserDetail, getUsers} from '@/api/admin';
import {useQuery} from '@tanstack/react-query';

export function useAdminUsers(page: number = 1, search: string = '', role: string = '') {
    return useQuery({
        queryKey: ['admin', 'users', {page, search, role}],
        queryFn: () => getUsers(page, search, role),
        keepPreviousData: true
    });
}

export function useAdminUserDetail(userId: string | null) {
    return useQuery({
        queryKey: ['admin', 'user', userId],
        queryFn: () => getUserDetail(userId!),
        enabled: !!userId
    });
}
